// @flow
import React, { Fragment, useEffect, useCallback, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import PlainLinkAsButton from 'app/common/ui-next/plain-link-as-button';

import styles from './RedirectToBank.module.scss';;


type Props = {
  redirectTo: string,
}

const RedirectToBank = ({ redirectTo }: Props) => {
  const { t } = useTranslation('finances');
  const link = useRef(null);
  const [timer, setTimer] = useState(5);

  const handleGotoBank = useCallback((el: HTMLElement | null) => {
    if (el) {
      link.current = el;
    }
  }, []);

  const handleTimer = useCallback(() => {
    setTimer((currentTimer) => {
      if (currentTimer === 0) {
        if (link.current) {
          link.current.click();
        }
        return currentTimer;
      }
      setTimeout(handleTimer, 1000);
      return currentTimer - 1;
    });
  }, []);

  useEffect(() => {
    setTimeout(handleTimer, 1000);
  }, []);


  return (
    <Fragment>
      {/* "Вы будете перенаправлены на сайт банка через {{timer}} сек." */}
      <div className={styles.redirectBankWarn}>
        {t('redirect_to_bank_warn', { timer })}
      </div>
      <PlainLinkAsButton
        to={redirectTo}
        className={styles.redirectBankBt}
        reference={handleGotoBank}
        openInSameWindow
      >
        {t('redirect_to_bank_bt', 'Перейти сейчас')}
      </PlainLinkAsButton>
    </Fragment>
  );
};

export default RedirectToBank;
